import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { generalService } from '../../../services/general.service';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { DataService } from '../../../utils/data.service';

@Component({
  selector: 'BalanceGeneral-consultar',
  templateUrl: './balanceGeneral-consultar.component.html',
  styleUrls: ['balanceGeneral-consultar.component.scss'],
  providers: [generalService]
})

export class BalanceGeneralConsultarComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) sort2: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('paginator2') paginator2: MatPaginator;
  @ViewChild('tableBalanceGeneral') tableBalanceGeneral: ElementRef;
  dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
  dataSource2: DataSourceGrid | MatTableDataSource<any> | null = null;
  myForm: FormGroup;
  fechaInicioOptions: { id: number, name: string }[] = [];
  public dataBalanceGeneralActivos: any[] = [];
  public dataBalanceGeneralPasivoCapital: any[] = [];
  public list_Nivel: any[] = [];
  public filteredDataNivel: any[] = [];
  public filteredDataNivel2: any[] = [];
  public balanceGeneralExcel: any[] = [];
  combinedData: any[] = [];
  public nivel = 0;
  public fechaExcel;
  public totalSaldoActivo = 0;
  public totalSaldoPasivosCapital = 0;
  displayedColumnsActivo = ['NUMEROCUENTA', 'NOMBRE', 'SALDO'];
  displayedColumnsPasivosCapital = ['NUMEROCUENTA2', 'NOMBRE2', 'SALDO2'];
  filteredData: any[] = [];
 filteredDataRANGE_3: any[] = [];
  
  constructor( public dialog: MatDialog,
    private formBuilder: FormBuilder,private _generalService: generalService,public dataService: DataService,) {
      this.generateFechaInicioOptions();
  }

  ngOnInit() {
    this.buildForm();
    this.getDataFilters();
  }

  buildForm(){
    const startMonthYear = this.fechaInicioOptions[0].id;
    this.myForm = this.formBuilder.group({
      nivelForm: ['', Validators.required],
      fechaInicio: [startMonthYear, Validators.required],
    });
  }

  getDataFilters() {
    this.list_Nivel= [];
    let metodo = 'BalanceGeneral/getLevel';
    const params = { 
        loacs: sessionStorage.getItem('acslo'),
    };

    this._generalService.metodoCallParams(params, metodo, true).subscribe(
      result => {
        const tableResult = JSON.parse(result);
        this.nivel = tableResult.Table[0]['LEVEL'];
        for(let i = this.nivel; i >= 1; i--){
          this.list_Nivel.push({
            nivel: i,
            NAME: i
          });
        }
        this.myForm.get('nivelForm').setValue(this.list_Nivel[0]['nivel']);
        this.consultar();
      },
      error => {  console.log(<any>error);  }
    );
  }

  generateFechaInicioOptions() {
    const currentDate = moment();
    for (let i = 0; i < 12; i++) {
      const date = currentDate.clone().subtract(i, 'months');
      this.fechaInicioOptions.push({
        id: parseInt(date.format('YYYYMM'), 10),
        name: date.format('MMMM YYYY')
      });
    }
  }
  
  consultar(){
    this.fechaExcel = '';
    let anio;
    
    this.totalSaldoActivo = 0;
    this.totalSaldoPasivosCapital = 0;
    this.filteredDataNivel = [];
    this.filteredDataNivel2 = [];
    this.balanceGeneralExcel = [];
    let nivel = this.myForm.controls['nivelForm'].value;
    const fechaInicio = String(this.myForm.get('fechaInicio').value);
    this.fechaExcel = fechaInicio;
    anio = parseInt(String(this.myForm.get('fechaInicio').value).substring(2, 4), 10);
    const numeromesInicio = fechaInicio.slice(-2); // Obtiene el último carácter
    const params = { 
      mes:numeromesInicio,
      anio:anio,
      loacs: sessionStorage.getItem('acslo')
    };
    
    this._generalService.metodoCallParams(params, 'BalanceGeneral/consultBalanceGenearl',true).subscribe(
        (result) => {
          const tableResult = JSON.parse(result);
          if(tableResult.Table != undefined || tableResult.Table != null){
            this.dataBalanceGeneralActivos = tableResult.Table;
            this.dataBalanceGeneralPasivoCapital = tableResult.Table2;
            const structuredData = this.structureData(this.dataBalanceGeneralActivos);
            const structuredData2 = this.structureData(this.dataBalanceGeneralPasivoCapital);
    
            this.filteredDataNivel = structuredData.filter(item => item.NIVEL <= nivel);
            this.filteredDataNivel2 = structuredData2.filter(item => item.NIVEL <= nivel);
            this.balanceGeneralExcel = [...this.filteredDataNivel, ...this.filteredDataNivel2];
            //this.dataSource = new MatTableDataSource(this.filteredDataNivel);
            // Utilizamos el método filter para eliminar los registros con type === 'RANGE_TYPE'
            this.filteredDataNivel = this.filteredDataNivel.filter(item => item.type !== 'RANGE_TYPE');
            this.filteredDataNivel2 = this.filteredDataNivel2.filter(item => item.type !== 'RANGE_TYPE');

            this.dataSource = new DataSourceGrid(this.filteredDataNivel, this.paginator, this.sort);
            //this.dataSource2 = new MatTableDataSource(this.filteredDataNivel2);
            this.dataSource2 = new DataSourceGrid(this.filteredDataNivel2, this.paginator2, this.sort2);

          }
          if (this.filteredDataNivel.length <= 0 || this.filteredDataNivel2.length <= 0) {
            $(".mat-row").remove(".mat-row");
          }          
          
        }, (error) => {
          console.log(error as any);
    });
  }


  structureData(data) {
    const result = [];
    const rangeTypeNames = [];
    let totalSaldoGeneral = 0; 
    let totalItemCount = 1;

    // Agrupar los datos por RANGE_TYPE_ID
    const groupedByRangeTypeId = data.reduce((acc, item) => {
        const { RANGE_TYPE_ID, RANGE_TYPE_NAME } = item;
        if (!acc[RANGE_TYPE_ID]) {
            acc[RANGE_TYPE_ID] = { RANGE_TYPE_NAME, items: [] };
        }
        acc[RANGE_TYPE_ID].items.push(item);
        return acc;
    }, {});

    // Iterar sobre cada grupo de RANGE_TYPE_ID
    Object.keys(groupedByRangeTypeId).forEach(rangeTypeId => {
        const rangeType = groupedByRangeTypeId[rangeTypeId];

        // Agregar el nombre del RANGE_TYPE a la lista de nombres
        rangeTypeNames.push(rangeType.RANGE_TYPE_NAME);

        // Crear el objeto rangeTypeItem con el nombre del RANGE_TYPE
        const rangeTypeItem = {
            RANGE_TYPE_ID: parseInt(rangeTypeId),
            type: 'RANGE_TYPE',
            name: rangeType.RANGE_TYPE_NAME.toUpperCase(),
            NIVEL: 0
        };

        // Agregar el rangeTypeItem al resultado
        result.push(rangeTypeItem);

        // Agrupar los datos dentro de cada RANGE_TYPE_ID por RANGE_ACCOUNT_ID
        const groupedByRangeAccountId = rangeType.items.reduce((acc, item) => {
            const { RANGE_ACCOUNT_ID, RANGE_ACCOUNT_DESCRIPTION } = item;
            if (!acc[RANGE_ACCOUNT_ID]) {
                acc[RANGE_ACCOUNT_ID] = {
                    RANGE_ACCOUNT_DESCRIPTION,
                    items: [],
                };
            }
            acc[RANGE_ACCOUNT_ID].items.push(item);
            return acc;
        }, {});

        // Agregar los RANGE_ACCOUNT al resultado y sumar los saldos iniciales al RANGE_TYPE
        Object.keys(groupedByRangeAccountId).forEach(rangeAccountId => {
            const rangeAccount = groupedByRangeAccountId[rangeAccountId];

            const totalSaldo = rangeAccount.items.reduce((acc, item) => {
              if (item.NIVEL === 1) {
                  acc += (item.Saldo || 0); // Suma el saldo
              }
              return acc;
          }, 0);
          
          
          if (parseInt(rangeTypeId) === 1) {
            totalSaldoGeneral += totalSaldo;
          } 
           if (parseInt(rangeTypeId) === 2 ) {
            totalSaldoGeneral += totalSaldo;
            } else if (parseInt(rangeTypeId) === 3) {
            totalSaldoGeneral -= totalSaldo;
          } 
            

            // Crear el objeto rangeAccountItem con la descripción del RANGE_ACCOUNT y saldo total
            const rangeAccountItem = {
                RANGE_TYPE_ID: parseInt(rangeTypeId), // Asignar el RANGE_TYPE_ID
                RANGE_ACCOUNT_ID: parseInt(rangeAccountId),
                RANGE_ACCOUNT_ID_index: parseInt(rangeAccountId),
                type: 'RANGE_ACCOUNT',
                name: rangeAccount.RANGE_ACCOUNT_DESCRIPTION,
                saldoTotal_RANGE_ACCOUNT: totalSaldo,
                NIVEL: 0
            };

            result.push(rangeAccountItem); // Añadir rangeAccountItem al principio

            // Agregar las filas de datos regulares debajo del RANGE_ACCOUNT si hay datos
            if (rangeAccount.items.length > 0) {
                result.push(...rangeAccount.items);
            }

            // Añadir el total como un nuevo objeto al final del grupo
            const totalItem = {
                RANGE_TYPE_ID: parseInt(rangeTypeId),
                RANGE_ACCOUNT_ID: parseInt(rangeAccountId),
                type: 'Total_RANGE_ACCOUNT',
                nameTotal: 'Total '+rangeAccount.RANGE_ACCOUNT_DESCRIPTION,
                saldoTotal_RANGE_ACCOUNT: totalSaldo,
                saldoTotalE_RANGE_ACCOUNT: totalSaldo,
                NIVEL: 0,
                NUMBER: '',
                NAME: '',
                
            };
            
            result.push(totalItem); // Añadir totalItem al final del grupo
        });
    });
    
    
    // Agregar la fila TOTAL al final del resultado
    const totalItem = {
        type: 'TOTAL',
        NIVEL: 0,
        NAME: '', // Para que no salga undefined en la tabla
        name_TotalGeneral: rangeTypeNames.join(', '), // Concatenar los nombres de RANGE_TYPE_NAME
        saldoTotal_GENERAL: totalSaldoGeneral, // Total de todos los saldos
        index : totalItemCount
    };
    
    result.push(totalItem);
    
    return result;
  }

  exportarExcel() {
    if (this.balanceGeneralExcel.length > 0) {
      // Filtra solo por RANGE_TYPE_ID === 1
      this.filteredData = this.balanceGeneralExcel.filter(item => item.RANGE_TYPE_ID === 1 || item.name_TotalGeneral === 'Activo');
      // Filtra por RANGE_TYPE_ID === 3 o 2
      this.filteredDataRANGE_3 = this.balanceGeneralExcel.filter(item => item.RANGE_TYPE_ID === 3 || item.RANGE_TYPE_ID === 2 || item.name_TotalGeneral === 'Pasivo, Capital'|| item.name_TotalGeneral === 'Pasivo - Capital');
      const filteredDataLength = Math.max(this.filteredData.length, this.filteredDataRANGE_3.length);
      const combinedData = [];
      //unimos this.filteredData y  this.filteredDataRANGE_3
      this.filteredDataRANGE_3.forEach(item => {
        // Verifica si el tipo es 'TOTAL' y el nombre es 'Pasivo, Capital'
        if (item.type === 'TOTAL' && item.name_TotalGeneral === 'Pasivo, Capital') {
            // Cambia el nombre a 'Pasivo - Capital'
            item.name_TotalGeneral = 'Pasivo - Capital';
        }
      });
      
      for (let i = 0; i < filteredDataLength; i++) {
        combinedData.push({
          data1: this.filteredData[i] || {}, 
          data2: this.filteredDataRANGE_3[i] || {} 
        });
      }

      this.combinedData = combinedData; 
      this.readyExport();
    }
  }

  readyExport() {
    const fechaInicio = this.fechaExcel; 
    const year = fechaInicio.substring(0, 4);
    const month = fechaInicio.substring(4);
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const monthName = monthNames[Number(month) - 1];
    const fechaExcelForm = monthName + ' ' + year;

    setTimeout(() => this.exportAsExcelFile("Balance General " + fechaExcelForm), 500);
  }

  exportAsExcelFile(filename: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableBalanceGeneral.nativeElement);
    const headersWorksheet = ['NUMERO DE CUENTA', 'NOMBRE', 'SALDO', 'ACTIVO', 'PASIVO', 'CAPITAL'];

   
    for (const z in worksheet) {
      if (z[0] === '!') continue; 

      const cell = worksheet[z];
      if (cell) {
        const col = z.replace(/[0-9]/g, ''); 

       
        if (headersWorksheet.indexOf(cell.v + '') > -1) {
          this.wrapAndCenterCell(cell, 'header'); 
        } else if (col === 'C') { 
          this.wrapAndCenterCell(cell, 'decimal'); 
        } else if (['F', 'G', 'H', 'I', 'L', 'M', 'N'].includes(col)) {
          this.wrapAndCenterCell(cell, 'decimal'); 
        } else if (col === 'O') {
          this.wrapAndCenterCell(cell, 'porcentaje'); 
        } else if (['D', 'H', 'K'].includes(col) && cell.t === 'n' && cell.z !== 'm/d/yy') {
          this.wrapAndCenterCell(cell, 'decimal'); 
        } else if (typeof cell.v === 'string' && cell.v.startsWith('$')) {
          this.wrapAndCenterCell(cell, 'decimal'); 
        }
      }
    }

   
    const workbook: XLSX.WorkBook = { Sheets: { General: worksheet }, SheetNames: ['General'] };
    const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });

    this.saveAsExcelFile(excelBuffer, filename);
  }
  
  saveAsExcelFile(buffer: any, filename: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(data, filename + '.xlsx');
  }

  wrapAndCenterCell(cell: XLSX.CellObject, tipo: string) {
    let cellStyle: any = { alignment: { vertical: 'center', horizontal: 'center' } }; 

    switch (tipo) {
      case 'header':
        cellStyle.font = { bold: true }; 
        break;
      case 'decimal':
        cellStyle.numFmt = '$#,##0.00'; 
        if (typeof cell.v === 'number' && cell.v < 0) {
          cellStyle.font = { color: { rgb: 'FF0000' } }; // Poner en rojo los valores negativos
        }
        break;
      case 'porcentaje':
        cellStyle.numFmt = '0.00%;\\(0.00%\\);\\-;@'; 
        break;
    }

    this.setCellStyle(cell, cellStyle); 
  }

  setCellStyle(cell: XLSX.CellObject, style: any) {
    cell.s = style;
  }  
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/balanceGeneral/consultar/balanceGeneral-consultar.component.ts